import dayjs from 'dayjs';

export const formatMoney = (val: number | string, withoutCurrencySymbol = false) => {
  const currency = 'USD';
  const moneyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    ...(withoutCurrencySymbol && { currencyDisplay: "code" })
  });
  const formatted = moneyFormatter.format(Number(val));

  return withoutCurrencySymbol ? formatted.replace(currency, '').trim() : formatted;
}

export const formatDate = (date: string, format?: string) => dayjs(date).format(format || 'DD.MM.YYYY');

export const plural = (forms: [string, string], count: number) => {
  return count === 1 ? forms[0] : forms[1];
};
